import Vue from 'vue'
import moment from 'moment'

Vue.filter("formDate", value => {
  if (!value) return '';
  return moment(value).format('DD/MM/YYYY hh:mm A')
})
